import { render } from "./JianDanLb.vue?vue&type=template&id=1fe8fa88&scoped=true&ts=true"
import script from "./JianDanLb.vue?vue&type=script&lang=ts"
export * from "./JianDanLb.vue?vue&type=script&lang=ts"

import "./JianDanLb.vue?vue&type=style&index=0&id=1fe8fa88&lang=less&scoped=true"

import exportComponent from "F:\\工作资料\\公司网站资料\\phone\\gtwebphone的副本\\gtwebphone的副本\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1fe8fa88"]])

export default __exports__